import { useCreateFormStore } from '@components/form';
import { Stack } from '@components/stack';

import { AttributeFieldType, TravellerAttributeTemplateData } from 'api/attributes/requests';

import {
  DetailsSection,
  FieldFormData,
  FieldFormWithUnsavedChangesPrompt,
  FormFooter,
  applyInputStatus,
} from './field-form-shared';

type SimpleFieldFormProps = {
  attributeType: AttributeFieldType;
  attribute?: TravellerAttributeTemplateData;
  isTravellerAttribute: boolean;
  onSubmit: (data: FieldFormData) => Promise<boolean>;
  isEditing: boolean;
};

export const SimpleFieldForm = ({
  attributeType,
  attribute,
  isTravellerAttribute,
  onSubmit,
  isEditing,
}: SimpleFieldFormProps) => {
  const formStore = useCreateFormStore();
  const isDirty = formStore.useIsDirty();

  const handleSubmit = async (data: FieldFormData) => {
    const submitData = applyInputStatus({ ...data, attributeType }, isTravellerAttribute);
    return onSubmit(submitData);
  };

  return (
    <FieldFormWithUnsavedChangesPrompt onSubmit={handleSubmit} store={formStore}>
      <Stack space={6}>
        <DetailsSection
          attributeType={attributeType}
          attribute={attribute}
          isTravellerAttribute={isTravellerAttribute}
        />
      </Stack>
      <FormFooter isEditing={isEditing} isDirty={isDirty} />
    </FieldFormWithUnsavedChangesPrompt>
  );
};
